import { fetchAuthSession } from "aws-amplify/auth";
import { redirectToHostedUI } from "./hostedUi";

const BASE = import.meta.env.VITE_API_BASE_URL || "http://localhost:8080/api";

const resolveUrl = (url: string): string => {
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BASE}${url}`;
  return `${BASE}/${url}`;
};

const buildHeaders = async (input?: HeadersInit): Promise<Headers> => {
  const headers = new Headers(input);
  try {
    const session = await fetchAuthSession();
    const raw: any = session?.tokens?.accessToken ?? null;
    const token =
      typeof raw === "string"
        ? raw
        : typeof raw?.toString === "function"
          ? raw.toString()
          : typeof raw?.token === "string"
            ? raw.token
            : null;
    if (token) headers.set("Authorization", `Bearer ${token}`);
  } catch {}
  return headers;
};

export async function http<TData = unknown, TError = unknown>(
  url: string,
  options?: RequestInit,
): Promise<TData> {
  const fullUrl = resolveUrl(url);
  const headers = await buildHeaders(options?.headers);
  const res = await fetch(fullUrl, {
    ...options,
    headers,
    credentials: options?.credentials ?? "include",
  });

  if (res.status === 401) {
    try {
      await redirectToHostedUI();
    } catch {}
    const bodyText = await res.text().catch(() => "");
    let error: any = { status: 401, title: "Unauthorized" };
    try {
      if (bodyText) error = { ...error, ...JSON.parse(bodyText) };
    } catch {}
    throw error as TError;
  }

  const bodyText = [204, 205, 304].includes(res.status)
    ? ""
    : await res.text().catch(() => "");
  if (!res.ok) {
    let error: any = { status: res.status };
    try {
      if (bodyText) error = { ...error, ...JSON.parse(bodyText) };
    } catch {}
    throw error as TError;
  }

  const data = bodyText ? JSON.parse(bodyText) : ({} as any);
  const result: any = { data, status: res.status, headers: res.headers };
  return result as TData;
}
